import React from 'react'
import FeatherIcon from 'feather-icons-react'

const bottomTopComponent = () => {
  const topFunction = () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // example logic
  };
  return (
    <button onClick={topFunction} className="btn btn-info btn-icon landing-back-top" id="back-to-top">
        <FeatherIcon icon="arrow-up" />;
    </button>
  )
}

export default bottomTopComponent